import { useNavigate } from 'react-router-dom';
import { ShieldCheck, Terminal, ArrowLeft, Home } from 'lucide-react';
import useSEO from '../hooks/useSEO';

export default function NotFound() {
  useSEO('/404', { title: 'Page introuvable | CyberGuard', description: "Cette page n'existe pas.", noindex: true });
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#09090b] flex flex-col items-center justify-center px-4 relative overflow-hidden">
      {/* Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[300px] bg-red-500/5 blur-[100px] pointer-events-none" />

      <div className="relative z-10 text-center space-y-8 max-w-lg">

        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-4">
          <ShieldCheck className="w-8 h-8 text-blue-500" />
          <span className="font-mono text-xl font-black text-white uppercase tracking-tighter">CyberGuard</span>
        </div>

        {/* Error code */}
        <div>
          <div className="text-[120px] font-black font-mono text-red-500/20 leading-none select-none">404</div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-red-500/10 border border-red-500/20 -mt-4">
            <Terminal className="w-3 h-3 text-red-400" />
            <span className="text-red-400 text-[10px] font-mono uppercase tracking-widest">Error_Page_Not_Found</span>
          </div>
        </div>

        {/* Message terminal */}
        <div className="bg-zinc-900 border border-zinc-800 rounded-sm p-6 text-left space-y-2 font-mono text-xs">
          <p className="text-zinc-600">$ cyberguard --navigate {window.location.pathname}</p>
          <p className="text-red-400">❌ ERROR: Route not found in secure registry</p>
          <p className="text-zinc-600">$ suggest --alternatives</p>
          <p className="text-green-400">→ / — Accueil</p>
          <p className="text-green-400">→ /dashboard — Tableau de bord</p>
          <p className="text-green-400">→ /audits/new — Launch new scan</p>
          <p className="text-green-400">→ /reports — View reports</p>
          <p className="text-zinc-600 animate-pulse">█</p>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-6 py-3 border border-zinc-700 text-zinc-400 hover:text-white hover:border-zinc-500 font-mono text-xs uppercase transition-all rounded-sm"
          >
            <ArrowLeft className="w-4 h-4" /> Page précédente
          </button>
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-mono text-xs uppercase transition-all rounded-sm font-bold"
          >
            <Home className="w-4 h-4" /> Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
}
